import ResponsivContent from "../../components/ResponsivContent";
import BusinessCenterOutlinedIcon from "@mui/icons-material/BusinessCenterOutlined";
import styles from "./styles.module.css";
import { Button, Checkbox, TextField } from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import ImgBPO from "../../images/bpo_produtos.png";
import ImgPEX from "../../images/pex_produtos.png";
import { useState } from "react";
import ReactCardFlip from "react-card-flip";
import HelpIcon from "@mui/icons-material/Help";
import CancelIcon from "@mui/icons-material/Cancel";
import ReactInputMask from "react-input-mask";
import { validarFormatacaoDocumento } from "../../services/validation.service";
import { cadastrarSugestaoDeServicos } from "../../services/api-planejamento-tributario.service";
import MensagemSucesso from "../../components/MensagemSucesso";
import { useNavigate } from "react-router-dom";
import MensagemErro from "../../components/MensagemErro";

//#region ------ componente card -------
const CardTiposDeNegocio = ({
  id,
  ImgChild,
  productName,
  productDescription,
  moreInfo,
  onChange,
  checked,
}) => {
  const [isFliped, setIsFliped] = useState(false);

  const flipedCard = () => {
    setIsFliped(!isFliped);
  };

  return (
    <>
      <ReactCardFlip flipDirection="horizontal" isFlipped={isFliped}>
        <div className={styles.cardContainer__front}>
          <label className={styles.cardContainer}>
            <input
              type="checkbox"
              className={styles.checkerCard}
              id={id}
              onChange={onChange}
              checked={checked}
            />
            <div className={styles.card}>{ImgChild}</div>
            <div className={styles.textContainer}>
              <div className={styles.productName}>{productName}</div>
              <hr className={styles.separador} />
              <div className={styles.productDescription}>
                {productDescription}
              </div>
            </div>
          </label>
          <span onClick={flipedCard} className={styles.buttonFlip}>
            <HelpIcon />
          </span>
        </div>

        <div className={styles.cardContainer__back}>
          <div className={styles.productName}>{productName}</div>
          <hr className={styles.separador__back} />
          <span className={styles.productDescription}>{moreInfo}</span>
          <span onClick={flipedCard} className={styles.buttonFlip}>
            <CancelIcon />
          </span>
        </div>
      </ReactCardFlip>
    </>
  );
};
//#endregion

const SugestaoDeServicos = () => {
  //region ---------- useStates -----------
  const [msg, setMsg] = useState("");
  const [openSnackbarSucesso, setOpenSnackbarSucesso] = useState(false);
  const handleOpenSnackbarSucesso = () => {
    setOpenSnackbarSucesso(true);
  };

  const handleCloseSnackbarSucesso = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbarSucesso(false);
  };

  const [openSnackbarErro, setOpenSnackbarErro] = useState(false);
  const handleOpenSnackbarErro = () => {
    setOpenSnackbarErro(true);
  };

  const handleCloseSnackbarErro = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbarErro(false);
  };

  const navigate = useNavigate();

  //region --------- objeto de envio ao endpoint ----------
  const [formData, setFormData] = useState({
    nome: "",
    email: "",
    whatsapp: "",
    cpf: "",
    termo: false,
    produtos: [],
  });
  //#endregion

  const [cpfError, setCpfError] = useState();
  const [emailError, setEmailError] = useState();
  const [errorGeneral, setGeneralError] = useState();

  //#endregion

  //#region -------- array de produtos -------
  const dataCards = [
    {
      id: 1,
      ImgChild: <img src={ImgBPO} alt="BPO" />,
      productName: "BPO",
      productDescription:
        "Assumimos todos os processos contábeis, fiscais e de Departamento Pessoal da sua empresa.",
      moreInfo:
        "Seja qual for o tamanho ou segmento da sua empresa. Atuamos em todo o Brasil e assumimos as atividades que não estejam relacionados ao seu negócio principal. Temos uma equipe especializada para desenvolvê-las de forma rápida, segura, transparente e com excelência. Realizamos um planejamento com minimização de riscos e olhar tributário. Trabalhamos com softwares específicos e reconhecidos no mercado (ERP’s), garantindo a entrega dos serviços com qualidade. Deixe a parte burocrática com a gente e concentre-se na lucratividade do seu negócio.",
    },
    {
      id: 2,
      ImgChild: <img src={ImgPEX} alt="PEX" />,
      productName: "Serviços Societários",
      productDescription:
        "Cuidamos dos registros de documentos e empresas em Juntas Comerciais, Cartórios, Receita Federal e outros órgãos públicos.",
      moreInfo:
        "Somos a segurança jurídica para o seu negócio decolar. Garantimos que a sua empresa esteja sempre em conformidade com regulamentações e leis específicas de acordo com a área de atuação. Aplicamos as melhores práticas de compliance e refutamos qualquer ação ilegal. Operamos com automações que aceleram a velocidade dos processos e melhoram os resultados de forma planejada. Tudo feito por um time de especialistas nas melhores práticas de governança e segurança da informação, cuidando dos assuntos burocráticos do seu dia a dia. São mais de 1.000 CNPJ’s abertos e 1.350 certidões emitidas.",
    },
  ];
  //#endregion

  //#region -------- controle de inputs e validação -----------

  // --------- handle default ------------
  const handleChange = async (event) => {
    const { name, value, checked } = event.target;

    setFormData((prevFormData) => {
      switch (name) {
        case "nome":
          return { ...prevFormData, nome: value };
        case "whatsapp":
          return { ...prevFormData, whatsapp: value };
        case "termo":
          return { ...prevFormData, termo: checked };
        default:
          return prevFormData;
      }
    });
  };

  // ------- CPF -----------
  const handleChangeCpf = async (event) => {
    const value = event.target.value;
    setFormData((prevFormData) => ({ ...prevFormData, cpf: value }));

    if (value && value.length === 14) {
      const isValid = await validarFormatacaoDocumento(value, "CPF");
      setCpfError(!isValid);
      if (isValid) {
        setCpfError(false);
      } else {
        setCpfError(true);
      }
    } else {
      setCpfError(null);
    }
  };

  //---------- produtos ------------
  const handleProductChange = (id) => {
    setFormData((prevState) => {
      if (prevState.produtos.includes(id)) {
        return {
          ...prevState,
          produtos: prevState.produtos.filter((productId) => productId !== id),
        };
      } else {
        return { ...prevState, produtos: [...prevState.produtos, id] };
      }
    });
  };

  // ------------- email ------------

  const handleChangeEmail = (event) => {
    const value = event.target.value;
    setFormData((prevFormData) => ({ ...prevFormData, email: value }));

    const isValid = (email) => {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    };

    if (value) {
      const isEmailValid = isValid(value);
      if (isEmailValid) {
        setEmailError(false);
      } else {
        setEmailError(true);
      }
    }
  };

  // ---------- Checkbox clear ----------
  const handleChangeClean = () => {
    setFormData((prevState) => ({
      ...prevState,
      produtos: [],
    }));
  };

  // ---------- validação geral ----------
  const handleValidacao = () => {
    let validado = true;

    const lista = Object.keys(formData);
    for (let index = 0; index < lista.length; index++) {
      switch (lista[index]) {
        case "nome":
          if (formData.nome === "") {
            validado = false;
          }
          break;
        case "email":
          if (emailError) {
            validado = false;
          }
          break;
        case "whatsapp":
          if (formData.whatsapp === "") {
            validado = false;
          }
          break;
        case "cpf":
          if (cpfError) {
            validado = false;
          }
          break;
        case "termo":
          if (formData.termo === false) {
            validado = false;
          }
          break;
        default:
          break;
      }
      // Remover o retorno dentro do loop
    }

    // Retornar o valor de 'validado' após o loop
    return validado;
  };
  //#endregion

  //#region ----- handleSubmit ---------
  const handleSubmit = async (e) => {
    e.preventDefault();

    const validacao = handleValidacao();


    if (validacao) {
      try {
        const response = await cadastrarSugestaoDeServicos(formData);
        setMsg(response.mensagem);
        handleOpenSnackbarSucesso();
        setTimeout(() => {
          navigate("/dashboard");
        }, 2000);
      } catch (error) {
        setMsg(error);
        handleOpenSnackbarErro();
      }
    } else {
      setMsg("Um ou mais campos estão em branco ou estão incorretos");
      handleOpenSnackbarErro();
      setGeneralError(true);
      setEmailError(true);
      setCpfError(true);

      setTimeout(() => {
        setGeneralError(undefined);
        setEmailError(undefined);
        setCpfError(undefined);
      }, 6000);
    }
  };
  //#endregion

  //#region ------ template -----------
  return (
    <main className={styles.container__respons}>
      <ResponsivContent maxWidth={"900px"}>
        <header className={styles.headerTitle}>
          <BusinessCenterOutlinedIcon
            sx={{
              color: "#18316e",
              fontSize: "5rem",
            }}
          />
          <h1>
            Não será possível seguir com a sua solicitação. <br />
            Porém, trouxemos outras soluções para o seu negócio.
          </h1>
        </header>
        <h2 className={styles.subtitle__header}>
          Nossos serviços aumentam a lucratividade da sua empresa com eficiência
          e segurança jurídica.
        </h2>
        <form className={styles.formData} onSubmit={handleSubmit}>
          <ResponsivContent maxWidth={"900px"}>
            <div className={styles.formContato}>
              <div className={styles.clientData}>
                <div className={styles.clientData__line}>
                  <TextField
                    error={errorGeneral}
                    name="nome"
                    size="small"
                    label="Nome"
                    value={formData.nome}
                    onChange={handleChange}
                    fullWidth
                  />
                  <TextField
                    error={emailError}
                    name="email"
                    size="small"
                    label="E-mail"
                    type="email"
                    value={formData.email}
                    onChange={handleChangeEmail}
                    fullWidth
                  />
                </div>
                <div className={styles.clientData__line}>
                  <ReactInputMask
                    mask="(99) 9 9999-9999"
                    maskChar={null}
                    value={formData.whatsapp}
                    onChange={handleChange}
                  >
                    {() => (
                      <TextField
                        error={errorGeneral}
                        size="small"
                        label="WhatsApp"
                        name="whatsapp"
                        inputProps={{ 'data-only': 'numeric' }}
                      />
                    )}
                  </ReactInputMask>

                  <ReactInputMask
                    mask="999.999.999-99"
                    maskChar={null}
                    value={formData.cpf}
                    onChange={handleChangeCpf}
                  >
                    {() => (
                      <TextField
                        name="cpf"
                        size="small"
                        label="CPF"
                        error={cpfError}
                        inputProps={{ 'data-only': 'numeric' }}
                      />
                    )}
                  </ReactInputMask>

                  <div className={styles.termo}>
                    <Checkbox
                      name="termo"
                      id="termos"
                      checked={formData.termo}
                      onChange={handleChange}
                    />
                    <span className={styles.spanText}>
                      Aceito os
                      <a
                        target="_blank"
                        href="https://wwww.taxationmind.com.br" /*alterar para o link dos termos*/
                        className={styles.destaqueSpan}
                      >
                        termos e condições
                      </a>
                      de uso.
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </ResponsivContent>

          <ResponsivContent>
            <div className={styles.productOptions}>
              <span className={styles.destaqueSpan__instru}>
                Selecione os serviços que ajudam a crescer o seu negócio.
              </span>
              <div className={styles.cardsContainer}>
                {dataCards.map((card) => (
                  <CardTiposDeNegocio
                    key={card.id}
                    id={card.id}
                    ImgChild={card.ImgChild}
                    productName={card.productName}
                    productDescription={card.productDescription}
                    moreInfo={card.moreInfo}
                    checked={formData.produtos.includes(card.id)}
                    onChange={(checked) =>
                      handleProductChange(card.id, checked)
                    }
                  />
                ))}
              </div>
              <div>
                <Checkbox id="none" onChange={handleChangeClean} />
                <span className={styles.destaqueSpan}>
                  Nenhuma das opções acima
                </span>
              </div>
            </div>
          </ResponsivContent>
          <div className={styles.buttonContainer}>
            <Button
              endIcon={<SendIcon />}
              className={styles.buttonSubmit}
              type="submit"
            >
              Prosseguir
            </Button>
          </div>
        </form>
      </ResponsivContent>
      <MensagemSucesso
        open={openSnackbarSucesso}
        handleClose={handleCloseSnackbarSucesso}
        msg={msg}
      />
      <MensagemErro
        open={openSnackbarErro}
        handleClose={handleCloseSnackbarErro}
        msg={msg}
      />
    </main>
  );
};
//#endregion

export default SugestaoDeServicos;
